import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import classes from "./CoursesPage.module.css"
import { FilterExtention, Filter, FilterTypesEnum, Filters, FilterItem } from "../../UI/Filter";
import BackArrowTitle from "../../UI/BackArrowTitle";
import Courses from "./Courses";
import { fetchCoursesData } from "../../../store/course-actions";
import { getClassByNum } from "../../../utils";

const CoursesPage = ({ getPassUrlFromCourse, title }) => {

    const { direction, lang, texts } = useSelector(state => state.translate);
    const { homeUrl, applicationId } = useSelector((state) => state.application);
    const courses = useSelector(state => state.courses.courses);
    const years = useSelector(state => state.studyYears.years);
    const navigate = useNavigate();
    const dispatch = useDispatch()

    useEffect(() => {
        if (!courses?.length && applicationId) {
            dispatch(fetchCoursesData());
        }
    }, [courses, applicationId])

    return (
        <div className={`${classes[direction]} ${classes.CoursesPageOverflow}`}>
            <div className={classes.CoursesPage}>
                <BackArrowTitle text={title} onClick={() => { navigate(`${homeUrl}`) }}></BackArrowTitle>

                <FilterExtention list={courses.map(c => {
                    const literalYear = years && years[`${c?.course?.year}`] && years[`${c?.course?.year}`][lang] && years[`${c?.course?.year}`][lang]
                    return { ...c, courseName: c?.course?.name, literalYear: literalYear, courseLang: c?.course?.lang, age: [c?.course?.fromClass, c?.course?.toClass] }
                }).sort((a, b) => b.course.year - a.course.year)
                } >
                    <Filters>
                        <Filter name="free" text={texts.freeFilter} type={FilterTypesEnum.free}></Filter>
                        <Filter name="courseName" text={texts.filterByDiscipline} type={FilterTypesEnum.values}></Filter>
                        <Filter name="literalYear" text={texts.filterByYear} type={FilterTypesEnum.values}></Filter>
                        <Filter name="courseLang" text={texts.filterByLanguage} type={FilterTypesEnum.valuesList} values={{ he: texts.he, ar: texts.ar }}></Filter>
                        <Filter name="age" text={texts.filterByAge} type={FilterTypesEnum.valuesList} values={[...Array(12)].map((x, i) => getClassByNum(i + 1))} ></Filter>
                    </Filters>
                    <FilterItem>
                        <Courses getPassUrlFromCourse={getPassUrlFromCourse}></Courses>
                    </FilterItem>
                </FilterExtention>
            </div>
        </div>
    )
}

export default CoursesPage;